import React, { useState } from 'react';
import LandingPageContainer from './landing.styles';

const LandingPage = () => {
    const mapNumbersToKeys = {
        one: 1,
        two: 2,
        three: 3,
    };

    const imageeLinks = {
        one: 'https://i.pinimg.com/564x/4e/98/ff/4e98ff64c9b587a3e92f89ecd4ef5791.jpg',
        two: 'https://i.ibb.co/3zFPqSm/landing.jpg',
        three: 'https://i.pinimg.com/564x/49/ef/69/49ef696dab260960ba3749a61409a254.jpg',
    };
    const [currentImage, setCurrentImage] = useState('two');

    const slider = (string) => setCurrentImage(string);

    const getKeyByValue = (object, value) => {
        return Object.keys(object).find((key) => object[key] === value);
    };

    return (
        <LandingPageContainer
            id="Landing"
            style={{ backgroundImage: `url('${imageeLinks[currentImage]}')` }}
        >
            <div className="overlay"></div>
            <div className="text">
                <div className="content">
                    <h2>
                        Hello World!
                        <br />
                        We Are Kasper We Make Art.
                    </h2>
                    <p>
                        Curabitur arcu erat, accumsan id imperdiet et, porttitor
                        at sem. Mauris blandit aliquet elit, eget tincidunt nibh
                        pulvinar a. Curabitur aliquet quam. Accumsan id
                        imperdiet et, porttitor at sem. Mauris blandit aliquet
                        elit, eget tincidunt.
                    </p>
                </div>
            </div>
            {mapNumbersToKeys[currentImage] !== 1 ? (
                <i
                    className="fas fa-angle-left change-background fa-2x"
                    onClick={() => {
                        slider(
                            getKeyByValue(
                                mapNumbersToKeys,
                                --mapNumbersToKeys[currentImage],
                            ),
                        );
                    }}
                ></i>
            ) : null}

            {mapNumbersToKeys[currentImage] !== 3 ? (
                <i
                    className="fas fa-angle-right change-background fa-2x"
                    onClick={() => {
                        slider(
                            getKeyByValue(
                                mapNumbersToKeys,
                                mapNumbersToKeys[currentImage] + 1,
                            ),
                        );
                    }}
                ></i>
            ) : null}
            <ul className="bullets">
                <li
                    onClick={() => slider('one')}
                    className={currentImage === 'one' ? 'active' : null}
                ></li>
                <li
                    onClick={() => slider('two')}
                    className={currentImage === 'two' ? 'active' : null}
                ></li>
                <li
                    onClick={() => slider('three')}
                    className={currentImage === 'three' ? 'active' : null}
                ></li>
            </ul>
        </LandingPageContainer>
    );
};
export default LandingPage;
